import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { isAfter } from "date-fns";

import {
  ButtonCTO,
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalStyle,
} from "./styles";

const BannerReclameAqui = (): JSX.Element => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isSessionExist = sessionStorage?.getItem(
      "@UltragazEmpresarial:userClosedBannerReclameAqui"
    );
    const date = new Date();
    const dateFinish = new Date(2022, 10, 18);
    const isAfterDate = isAfter(date, dateFinish);

    if (isSessionExist === null && !isAfterDate) {
      setShow(true);
    }
  }, []);

  const onHide = (): void => {
    setShow(false);
    sessionStorage.setItem(
      "@UltragazEmpresarial:userClosedBannerReclameAqui",
      "true"
    );
  };

  return (
    <ModalStyle show={show} onHide={onHide} centered>
      <ModalContainer>
        <ModalHeader>
          <MdClose size={24} onClick={onHide} />
        </ModalHeader>
        <ModalContent
          onClick={onHide}
          href="https://www.reclameaqui.com.br/premio/votacao/empresa/ultragaz"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/static/banner-reclameaqui.png" alt="Reclame aqui" />
          <ButtonCTO>Votar</ButtonCTO>
        </ModalContent>
      </ModalContainer>
    </ModalStyle>
  );
};

export default BannerReclameAqui;
